module.exports = __webpack_public_path__ + "static/media/logo.45d36ab7.png";